import type { EditorState } from 'draft-js';
import type { FC } from 'types/react';

import { isStyleApplied } from '../../helpers/is-style-applied';
import { MonospaceIcon } from './static_assets';
import { Button } from './styles';

interface Props {
    editorState: EditorState;
    onClick: () => void;
}

export const MonospaceButton: FC<Props> = ({ editorState, onClick }) => (
    <Button $isActive={isStyleApplied('CODE', editorState)} onClick={onClick}>
        <MonospaceIcon />
    </Button>
);
